import Teleport from './Teleport.vue'

export default Teleport
